var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81.298,
    height: 82.119,
    viewBox: "0 0 81.298 82.119",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13442",
    "data-name": "Group 13442",
    transform: "translate(-1287.882 -339.883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-message-square",
    "data-name": "Icon feather-message-square",
    d: "M4.5,49.047a7.425,7.425,0,0,0,7.425,7.425H56.472L71.321,71.321v-59.4A7.425,7.425,0,0,0,63.9,4.5H11.925A7.425,7.425,0,0,0,4.5,11.925Z",
    transform: "translate(1283.382 335.383)",
    fill: "#0491a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-message-square-2",
    "data-name": "Icon feather-message-square",
    d: "M4.5,49.418A7.486,7.486,0,0,0,11.986,56.9H56.9L71.876,71.876V11.986A7.486,7.486,0,0,0,64.39,4.5h-52.4A7.486,7.486,0,0,0,4.5,11.986Z",
    transform: "translate(1295.804 348.626)",
    fill: "#f9f9f9",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17418",
    "data-name": "Path 17418",
    d: "M4.108,0A4.108,4.108,0,1,1,0,4.108,4.108,4.108,0,0,1,4.108,0Z",
    transform: "translate(1312.629 374.489)",
    fill: "#0491a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17417",
    "data-name": "Path 17417",
    d: "M4.108,0A4.108,4.108,0,1,1,0,4.108,4.108,4.108,0,0,1,4.108,0Z",
    transform: "translate(1329.884 374.489)",
    fill: "#0491a4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17416",
    "data-name": "Path 17416",
    d: "M4.108,0A4.108,4.108,0,1,1,0,4.108,4.108,4.108,0,0,1,4.108,0Z",
    transform: "translate(1347.139 374.489)",
    fill: "#0491a4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.cbe7f5820d4296b0e0076500f403973d.svg";
export { ForwardRef as ReactComponent };